import { render, staticRenderFns } from "./AlertRecord.vue?vue&type=template&id=0d460fd7&scoped=true&"
import script from "./AlertRecord.vue?vue&type=script&lang=js&"
export * from "./AlertRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d460fd7",
  null
  
)

export default component.exports